module.exports = __webpack_public_path__ + "img/cxq_icon.a94e366.png";